import styled from 'styled-components';

const H1 = styled.h1`
  margin: 0;
`;

export default H1;


// WEBPACK FOOTER //
// ./src/components/SubHeader/H1.js